import { render, staticRenderFns } from "./IcoTestContent.vue?vue&type=template&id=1134a93f"
import script from "./IcoTestContent.vue?vue&type=script&lang=js"
export * from "./IcoTestContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports